import { Snackbar, styled } from '@mui/material';
import { forwardRef } from 'react';

const StyledSnackbar = styled(Snackbar)(() => {
    return {
    };
});

export default forwardRef((props, ref) => {
    return <StyledSnackbar ref={ref} {...props} />;
});
